var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVioletBorderCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "183px",
    height: "183px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(122, 0, 230)",
    d: "M91.503,183.2 C41.47,183.2 0.1,141.952 0.1,91.496 C0.1,41.40 41.47,0.7 91.503,0.7 C141.959,0.7 183.8,41.40 183.8,91.496 C183.8,141.952 141.959,183.2 91.503,183.2 ZM91.503,16.975 C50.412,16.975 16.981,50.404 16.981,91.496 C16.981,132.588 50.412,166.18 91.503,166.18 C132.595,166.18 166.24,132.588 166.24,91.496 C166.24,50.404 132.595,16.975 91.503,16.975 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVioletBorderCircle);
export default __webpack_public_path__ + "static/media/violet-border-circle.73f78e287c6f26908e880ee320f4ca93.svg";
export { ForwardRef as ReactComponent };